<script setup>
import {computed, inject, ref, watch} from "vue";

const props = defineProps({
    containerRef: {
        type: String,
        required: true
    },
    block: {
        type: Object,
        required: true
    },
})

let anchorableId = null
try {
    anchorableId = props.block.uuid?.substring(props.block.uuid?.length - 12)
} catch (e) {
    console.error(e)
}

const formDatastore = inject('formDatastore');
const fieldValue = ref(null)
watch(() => fieldValue.value, (value) => {
    formDatastore.fields[props.uuid] = value;
});

const presetStyleClasses = computed(() => {
    let styles = [];

    if (!props.block.design?.settings) {
        return null;
    }

    if (props.block.design.settings.paddingPreset) {
        styles.push(`pbb-ps-padding-top__${props.block.design.settings.paddingPreset.top}`);
        styles.push(`pbb-ps-padding-right__${props.block.design.settings.paddingPreset.right}`);
        styles.push(`pbb-ps-padding-bottom__${props.block.design.settings.paddingPreset.bottom}`);
        styles.push(`pbb-ps-padding-left__${props.block.design.settings.paddingPreset.left}`);
    }

    return styles.join(' ');
})

const isScoreCondition = (condition) => {
    return condition?.type === 'score' || condition?.min !== undefined || condition?.max !== undefined
}

const isWithinScoreRange = (condition, fieldValue) => {
    const normalizedValue = Number(fieldValue)

    if (Number.isNaN(normalizedValue)) {
        return false
    }

    const min = condition?.min ?? null
    const max = condition?.max ?? null

    if (min !== null && normalizedValue < Number(min)) {
        return false
    }

    if (max !== null && normalizedValue > Number(max)) {
        return false
    }

    return true
}

const displayField = computed(() => {
    let display = true
    if (props.block.conditions && props.block.conditions.or && props.block.conditions.or.length > 0) {
        display = false

        if (Object.keys(formDatastore.fields).length > 0) {
            props.block.conditions.or.forEach(condition => {
                if (display) {
                    return
                }

                const fieldValue = formDatastore.fields[condition.inputUuid]

                if (fieldValue === undefined || fieldValue === null) {
                    return
                }

                if (isScoreCondition(condition)) {
                    if (isWithinScoreRange(condition, fieldValue)) {
                        display = true
                    }
                    return
                }

                if (Array.isArray(fieldValue) && fieldValue.includes(condition.alternative)) {
                    display = true
                }
            })
        }
    }

    return display
});


</script>
<template>
    <div
        class="styleable-block anchorable"
        :id="anchorableId"
        :class="[displayField ? '' : 'hidden', presetStyleClasses]"
    >
        <component
            :is="'page-builder-block-view-' + props.block.type"
            :container-ref="containerRef"
            v-bind="props.block"
            :data-blocktype="props.block.type"
        ></component>
    </div>
</template>
